import { styled } from '@linaria/react';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';

const TagsGroup = styled.div`
  display: flex;
  column-gap: 8px;
  position: absolute;

  z-index: 1;
  top: -12px;
  left: 16px;
`;

const PopTopicGroupTagsSkeleton = () => {
  return (
    <TagsGroup>
      {Array.from({ length: 3 }).map((_, index) => (
        <RectangleSkeleton key={index} width={44} height={24} />
      ))}
    </TagsGroup>
  );
};

export default PopTopicGroupTagsSkeleton;
